import { restApiIP } from "@plannel/services/utils/rest-api";

const getAll = (params) => {
  return restApiIP.get("/api/target-inv-eval", { params });
};

const getAllForCSV = params => {
  return restApiIP.get("/api/target-inv-eval/csv", { params });
};

const getOverview = () => {
  return restApiIP.get("/api/target-inv-eval/overview");
};

const get = id => {
  return restApiIP.get(`/api/target-inv-eval/${id}`);
};

const runEvaluation = params => {
  return restApiIP.post("/api/target-inv-eval/run", params);
};

const getDeployedStrategy = () => {
  return restApiIP.get("/api/target-inv-eval/deployed-strategy");
};

const applyEvaluation = () => {
  return restApiIP.post("/api/target-inv-eval/apply");
}

const targetInvEvalService = {
  getAll,
  getAllForCSV,
  getOverview,
  get,
  runEvaluation,
  getDeployedStrategy,
  applyEvaluation
};

export default targetInvEvalService;